import { BoardProps, BoardEditorProps } from './Board.types';

/**
 * 기존 데이터 형식을 새로운 형식으로 변환
 * 
 * @param originalProps 기존 Board 컴포넌트의 props
 * @returns 변환된 새로운 Board 컴포넌트용 props
 */
export function adaptBoardProps(originalProps: any): BoardProps {
  // 기본값 설정 (빈 객체로 초기화)
  const originalStyle = originalProps?.style || {};
  const originalData = originalProps?.data || {};
  
  // 스타일 객체 구성
  // device 속성과 deviceProperty 모두 유지
  const style = {
    ...originalStyle,
    device: originalStyle.device || undefined,
    deviceProperty: originalStyle.deviceProperty || undefined,
    __forceUpdatePadding: originalStyle.__forceUpdatePadding || undefined
  };
  
  // 데이터 객체 구성
  const data = Array.isArray(originalData) 
    ? { items: originalData } // 배열인 경우 items로 변환
    : { // 객체인 경우 모든 속성 유지하고 특정 속성은 명시적으로 처리
        ...originalData,
        title: originalData.title || '',
        parameter: originalData.parameter || '',
        items: originalData.items || [],
        showNewButton: originalData.showNewButton !== undefined ? originalData.showNewButton : true, 
        showDetailButtons: originalData.showDetailButtons !== undefined ? originalData.showDetailButtons : true,
        device: originalData.device ? {
          pc: {
            ...originalData.device?.pc,
            title: originalData.device?.pc?.title || '',
            parameter: originalData.device?.pc?.parameter || '',
            showNewButton: originalData.device?.pc?.showNewButton !== undefined 
              ? originalData.device.pc.showNewButton 
              : true
          },
          mobile: {
            ...originalData.device?.mobile,
            title: originalData.device?.mobile?.title || '',
            parameter: originalData.device?.mobile?.parameter || '',
            showNewButton: originalData.device?.mobile?.showNewButton !== undefined 
              ? originalData.device.mobile.showNewButton 
              : true
          }
        } : undefined
      };
  
  // 변환된 props 반환
  const adaptedProps: BoardProps = {
    style,
    data,
    id: originalProps?.id || '',
    className: originalProps?.className || '',
    onClick: originalProps?.onClick || undefined,
    viewMode: originalProps?.viewMode || 'pc'
  };

  // 원본 props의 모든 속성 중 이미 처리한 속성 제외하고 나머지 복사
  const excludeKeys = ['style', 'data', 'id', 'className', 'onClick', 'viewMode'];
  
  Object.keys(originalProps).forEach(key => {
    if (!excludeKeys.includes(key)) {
      (adaptedProps as any)[key] = originalProps[key];
    }
  });

  return adaptedProps;
}

/**
 * 에디터용 데이터 형식 변환
 * 
 * @param originalProps 기존 Board 컴포넌트의 props
 * @returns 변환된 에디터 컴포넌트용 props
 */
export function adaptBoardEditorProps(originalProps: any): BoardEditorProps {
  // 기본 props 변환 사용
  const adaptedProps = adaptBoardProps(originalProps);
  
  // 에디터 관련 추가 props
  return {
    ...adaptedProps,
    isSelected: originalProps.isSelected || false,
    isPreview: originalProps.isPreview || false,
    updateComponent: originalProps.updateComponent || (() => {})
  };
} 